import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFaceId: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="face-id"><path d="M12.25 8V11C12.25 12.1046 11.3546 13 10.25 13" stroke="currentColor" strokeWidth="1.5"/><path d="M8.25 3.75H3.75V8.25M3.75 15.75V20.25H8.25M15.75 3.75H20.25V8.25M20.25 15.75V20.25H15.75M7.75 8.75V10.25M16.25 8.75V10.25M9 15.6973C9.88252 16.2078 10.9071 16.5 12 16.5C13.0929 16.5 14.1175 16.2078 15 15.6973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFaceId;
